'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GiftUpAppIcon = function GiftUpAppIcon(props) {
  /**/
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 205 205"
  }), React__default["default"].createElement("g", {
    style: {
      isolation: 'isolate'
    }
  }, React__default["default"].createElement("g", {
    dataName: "Layer 1"
  }, React__default["default"].createElement("polygon", {
    points: "92.95 25.13 65.61 25.13 75.29 10.63 79.28 4.66 82.14 8.95 92.95 25.13"
  }), React__default["default"].createElement("circle", {
    cx: "102.54",
    cy: "105.17",
    r: "97.41"
  }), React__default["default"].createElement("path", {
    fill: "#fc0",
    d: "M124.65,81.23H112.84v21.25h12.11c7.64,0,12.11-4.57,12.11-10.52v-.2C137.06,84.9,132.3,81.23,124.65,81.23Z"
  }), React__default["default"].createElement("path", {
    fill: "#fc0",
    d: "M102.54,6.72A99.29,99.29,0,0,0,87.76,7.84L76.32.37,92.71,25h0l-.21-.61H86.93v82.3c0,21-11.81,31.37-30.48,31.37s-30.08-10.42-30.08-30.87V67.43H41.66v39.31c0,11.32,5.66,17.17,15,17.17s15-5.66,15-16.68V24.34H66.28l9.23-13.85a98.93,98.93,0,1,0,27-3.77Zm50,84.93c0,16.08-12.51,24.42-28.09,24.42H112.84v20.85H97.55V67.43h28.39c16.58,0,26.61,9.83,26.61,24Zm22.13,45.27H158.6V121h16.08Zm-3.87-23.63h-8.34l-4.67-43.88v-2h17.67v2Z"
  }))));
};

var GiftUpAppIcon$1 = iconStyles()(GiftUpAppIcon);

module.exports = GiftUpAppIcon$1;
